const initialState = true;

export default function MenuOpenCloseReducer(state = initialState, action) {
    switch (action.type) {
        case 'PUT_MENUOPENCLOSE':
            return action.condition;
        case 'CLEAR_MENUOPENCLOSE':
            return initialState;
        case 'CHANGE_MENUOPENCLOSE':
            return !state;
        default:
            return state;
    }
}